import { Flex, Box } from 'rebass/styled-components'
import CommunicatorWrapper from './components/CommunicatorWrapper';

interface ICommunicatorProps {
  conversationId: number | string
  onSelectConversation: (c:string)=>void
  athenaId?:string | undefined
}

export const Communicator: React.FC<ICommunicatorProps> = ({ conversationId,onSelectConversation, athenaId }) => {
  let convoId
  try {
    convoId = parseInt(conversationId.toString(), 10)
  } catch (error) {

  }
  if (!convoId || isNaN(convoId)) {
    return <Box />
  }
  console.log('Communicator', athenaId)
  return (
    <Flex flex={1} style={{ height: '100%', maxHeight: '100%' }}>
      <CommunicatorWrapper athenaId={athenaId} conversationId={convoId} onSelectConversation={onSelectConversation} />
    </Flex>);
}
